export default "__VITE_PUBLIC_ASSET__4bd39961__"